var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plan-icon ml-1 mr-1"},[_c('img',{attrs:{"src":_vm.getIcon}})])}
var staticRenderFns = []

export { render, staticRenderFns }